import { put, call } from 'redux-saga/effects';
import { questionnaireEvaluationGetRequestSuccessAction, questionnaireEvaluationFailureAction } from '../actions';
import { QuestionnaireEvaluationService } from '../services';
export function* questionnaireEvaluationGetSaga(action, 
/*istanbul ignore next*/
questionnaireEvaluationQuestionsService = new QuestionnaireEvaluationService()) {
    try {
        const questionnaireEvaluationQuestionData = yield call({
            context: questionnaireEvaluationQuestionsService,
            fn: questionnaireEvaluationQuestionsService.getAllQuestionaireEvaluation
        }, action.payload);
        yield put(questionnaireEvaluationGetRequestSuccessAction(questionnaireEvaluationQuestionData));
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
//# sourceMappingURL=questionnaireEvaluationGetSaga.js.map